var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.title,"effect":"light","open-delay":200,"placement":"top"}},[_c('small',{staticClass:"border rounded px-2 font-weight-bold mr-2",class:this.style},[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }